import React, { useContext, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  Box,
  CssBaseline,
  Typography,
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

import Loading from "./Loading";
import { DataContext } from "../context/DataContext";
import NavBarElements from "./NavBarElements";
import NavLinks from "./links/NavLinks";
import SidebarFooter from "./SidebarFooter";
import { isEmpty } from "lodash";

import Unautorized from "./Unautorized";

import { getUser } from "../api/Account";

import { Rutas } from "./Rutas";
import { useLocation } from "react-router-dom";
import { getAppTheme, sidebar } from "../theme";
import { getRuta } from "../helpers/Helpers";

const SIDEBAR_WIDTH = 236;

const SidebarContent = ({ docTitle, icon, setIsLogged, setIsDarkMode }) => (
  <Box sx={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: sidebar.bg }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: "11px", padding: "20px 20px 18px" }}>
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: "9px",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 3px 10px rgba(0,161,82,.35)",
        }}
      >
        <img loading="lazy" src={icon} alt="logo" style={{ width: 26, height: 26, objectFit: "contain" }} />
      </Box>
      <Box sx={{ lineHeight: 1.1 }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 16, letterSpacing: "-.2px" }}>
          {docTitle}
        </Typography>
        <Typography sx={{ fontSize: 10, color: "#66788f", letterSpacing: ".6px", fontWeight: 600 }}>
          GESTIÓN DE CRÉDITO
        </Typography>
      </Box>
    </Box>

    <Box sx={{ flex: 1, overflowY: "auto", padding: "6px 12px" }}>
      <NavLinks drawerIsOpen />
    </Box>

    <SidebarFooter setIsLogged={setIsLogged} setIsDarkMode={setIsDarkMode} />
  </Box>
);

export default function MiniDrawer() {
  const { isDarkMode, setIsDarkMode, access, docTitle, icon, setIsLogged } =
    useContext(DataContext);
  const isMobile = useMediaQuery("(max-width:599.95px)");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const isHome = location.pathname === `${getRuta()}/`;

  const user = getUser();

  useEffect(() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobile]);

  const tema = getAppTheme(isDarkMode);

  if (isEmpty(access)) {
    return <Loading />;
  }

  if (user === null) {
    setIsLogged(false);
    return null;
  }

  return (
    <>
      <ThemeProvider theme={tema}>
        <Box sx={{ display: "flex", height: "100vh", width: "100%", overflow: "hidden" }}>
          <CssBaseline />

          {isMobile ? (
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
              ModalProps={{ keepMounted: true }}
              PaperProps={{ sx: { width: SIDEBAR_WIDTH, border: "none" } }}
            >
              <SidebarContent docTitle={docTitle} icon={icon} setIsLogged={setIsLogged} setIsDarkMode={setIsDarkMode} />
            </Drawer>
          ) : (
            <Box component="aside" sx={{ width: SIDEBAR_WIDTH, flexShrink: 0 }}>
              <SidebarContent docTitle={docTitle} icon={icon} setIsLogged={setIsLogged} setIsDarkMode={setIsDarkMode} />
            </Box>
          )}

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, height: "100%" }}>
            <AppBar
              position="static"
              elevation={0}
              sx={{
                height: 60,
                flexShrink: 0,
                backgroundColor: "background.paper",
                borderBottom: "1px solid",
                borderColor: "divider",
                color: "text.primary",
              }}
            >
              <Toolbar sx={{ height: "100%", minHeight: "60px !important", paddingX: "24px" }}>
                {isMobile ? (
                  <IconButton onClick={() => setMobileOpen(true)} edge="start" sx={{ marginRight: "12px" }}>
                    <MenuRoundedIcon />
                  </IconButton>
                ) : null}
                <NavBarElements />
              </Toolbar>
            </AppBar>

            <Box component="main" sx={{ flex: 1, overflowY: "auto", padding: { xs: "16px", sm: "26px 28px 40px" } }}>
              <Box sx={{ maxWidth: isHome ? "none" : 1180, margin: "0 auto" }}>
                <Rutas />
              </Box>
            </Box>
          </Box>
        </Box>
        <Loading />
      </ThemeProvider>
      <Unautorized />
    </>
  );
}
